import TabItem from '@kasasa/portal-components/src/components/types/tabitem';

const tabItems: (TabItem) [] = [
  // { icon: 'sync', label: 'Account Core', link: '/accountcore' },
  // { icon: 'sync', label: 'Account Product', link: '/accountproduct' },
  { icon: 'sync', label: 'Whitelist FIs', link: '/genericwhitelist' },
  { icon: 'sync', label: 'File Mover', link: '/filemover' },
  { icon: 'sync', label: 'Mulesoft Fi', link: '/mulesoftfi' },
  { icon: 'sync', label: 'Mulesoft Core', link: '/mulesoftcore' },
  { icon: 'sync', label: 'Ghost Loan', link: '/ghostloan' },
  { icon: 'sync', label: 'Payment Processor', link: '/paymentprocessor' },
  { icon: 'sync', label: 'Nxtsof', link: '/nxtsoffi' },
  { icon: 'sync', label: 'Loan Importer', link: '/cldloanimporter' },
  { icon: 'sync', label: 'Decision Engine', link: '/meridianlink' },
];

export default tabItems;
